import React from 'react'
import '../css/App.css';
import Header from './Header'
import Nav from './Nav'
import Main from './Main'
import Footer from './Footer'

const App = () => (
  <div>
    <Header />
    <Nav />
    <Main />
    <Footer />
  </div>
)

export default App